/*
 * Copyright © 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Grid, InputAdornment, InputProps } from "@mui/material";
import React, { ElementType, useEffect } from "react";
import { ThousandsNumberInput } from "../FormFields/MaskedInputs/ThousandsNumberInput";
import { ThousandsNumberInputFloat } from "../FormFields/MaskedInputs/ThousandsNumberInputFloat";
import { ThousandsNumberInputFloatScaleThree } from "../FormFields/MaskedInputs/ThousandsNumberInputFloatScaleThree";
import { TextFieldElement, TextFieldElementProps } from "react-hook-form-mui";
import { floatFieldDefaultFieldBased, numberFieldDefaultFieldBased } from "../../services/reactHookFormValidationRules";
import { InputBaseComponentProps } from "@mui/material/InputBase";

export type NumberFieldElementProps = {
  name: string;
  label: string;
  validators?: Record<string, any>;
  numberType?: "float" | "int";
  fieldType?: "money" | "percentage" | "kilometers" | null;
  floatScaleThree?: boolean;
  inputProps?: any;
} & TextFieldElementProps;
export default function NumberFieldElement({
  name,
  label,
  validators = {},
  numberType = "int",
  fieldType = null,
  inputProps = null,
  floatScaleThree = false,
  ...rest
}: NumberFieldElementProps) {
  useEffect(() => {
    if (numberType === "int") {
      validators = { ...validators, ...numberFieldDefaultFieldBased };
    }
    if (numberType === "float") {
      validators = { ...validators, ...floatFieldDefaultFieldBased };
    }
  }, []);

  const endAdornments = {
    money: "€",
    percentage: "%",
    kilometers: "km",
  };

  function getInputComponent() {
    if (numberType === "int") {
      return ThousandsNumberInput;
    }
    return floatScaleThree ? ThousandsNumberInputFloatScaleThree : ThousandsNumberInputFloat;
  }

  return (
    <Grid size={12}>
      <TextFieldElement
        name={name}
        label={label}
        rules={validators}
        slotProps={{
          input: {
            inputComponent: getInputComponent(),
            endAdornment: !!fieldType ? (
              <InputAdornment position={"end"}>{endAdornments[fieldType]}</InputAdornment>
            ) : null,
          },
          htmlInput: {
            ...inputProps,
          },
        }}
        {...rest}
      />
    </Grid>
  );
}
